import { ITrustLevel } from '../model/types';

const toTitleCase = (snake: string): string =>
  snake
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

export const formatTrustLevelName = (level: ITrustLevel): string => {
  if (!level) return '—';
  return toTitleCase(level.name);
};

export const formatTrustLevel = (level: ITrustLevel): string => {
  if (!level) return '—';

  const titled = toTitleCase(level.name);
  const num = Number(level.percent);
  const pct = Number.isFinite(num) ? num.toString() : level.percent;
  return `${titled} — ${pct}%`;
};
